import React from 'react';

const AddIcon = ({ className = "me-2", ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className} {...props}>
        <path d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM11.5 9H9V11.5H7V9H4.5V7H7V4.5H9V7H11.5V9Z" fill="white" />
    </svg>
);
export default AddIcon;